import React from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Paper,
    Grid,
    IconButton,
    Typography,
    Tooltip
} from '@material-ui/core';

import ConfirmationDialog from './../shared/ConfirmationDialog';

//Icons
import AddIcon from '@material-ui/icons/AddCircleRounded';
import EditIcon from '@material-ui/icons/EditRounded';
import ManageStateIcon from '@material-ui/icons/EditAttributesRounded';
import ExtendIcon from '@material-ui/icons/EventRounded';
import DisassociaIcon from '@material-ui/icons/CancelScheduleSendRounded';
import ModuliIcon from '@material-ui/icons/ListAltRounded';
import BackIcon from '@material-ui/icons/ArrowBackIosRounded';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paper: {
        display: 'flex',
        justifyContent: 'center',
        height: 'auto',
        padding: '10px',
        marginBottom: '5px'
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '5px !important',
        paddingBottom: '5px !important',
    },
    icon: {
        fontSize: '2.5rem',
    },
    button: {
        padding: '5px',
        color: '#40404a',
    },
    greenButton: {
        padding: '5px',
        color: '#46a046'
    },
    redButton: {
        padding: '5px',
        color: '#d9534f'
    },
    blueButton: {
        padding: '5px',
        color: '#337ab7'
    }
});



class ToolbarGestioneLicenzeCmp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isResetLicenseDialogOpen: false,
            isResetEditLicenseDialogOpen: false,
            isResetNewModuliDialogOpen: false,
        };

        this.manageBackButton = this.manageBackButton.bind(this);
        this.showResetDialog = this.showResetDialog.bind(this);

        this.resetNewLicense = this.resetNewLicense.bind(this);
        this.resetNewModuli = this.resetNewModuli.bind(this);
        this.resetEditLicense = this.resetEditLicense.bind(this);
    }

    showResetDialog(type) {
        this.setState({ [type]: !this.state[type] });
    }

    // se ad es. selected_view === 'Crea Nuova' mostra dialog che chiede se annullare le modifiche
    manageBackButton() {
        if (this.props.selected_view === 'Crea Nuova')
            this.showResetDialog('isResetLicenseDialogOpen');
        else if (this.props.selected_view === 'Gestione Moduli')
            this.showResetDialog('isResetNewModuliDialogOpen');
        else if (this.props.selected_view === 'Modifica')
            this.showResetDialog('isResetEditLicenseDialogOpen');
        else this.props.changeViewSelection('');
    }

    resetNewLicense() {
        this.props.resetCreateLicense();
        this.props.changeViewSelection('');
    }

    resetNewModuli() {
        this.props.resetModuli();
        this.props.changeViewSelection('');
    }

    resetEditLicense() {
        this.props.resetEditLicenseData();
        this.props.changeViewSelection('');
    }


    render() {
        const { classes, selection, selected_view, changeViewSelection,
            showEditDataScadDialog, showGestioneStatoDialog, showDisassociaDialog } = this.props;
        const { isResetLicenseDialogOpen, isResetEditLicenseDialogOpen, isResetNewModuliDialogOpen } = this.state;


        const listViews = [
            'Crea Nuova',
            'Modifica',
            'Estendi',
            'Gestione Moduli',
        ];

        return (
            <Paper variant="outlined" className={classes.paper}>
                <Grid container spacing={3} >
                    {selected_view !== '' ?
                        <Grid item xs={2} className={classes.alignCenter} >
                            <IconButton
                                className={classes.blueButton}
                                aria-label="indietro"
                                onClick={() => { this.manageBackButton() }}
                            >
                                <Tooltip title="Indietro" >
                                    <BackIcon className={classes.icon} />
                                </Tooltip>
                            </IconButton>
                        </Grid>
                        : null
                    }

                    <Grid item xs={selected_view === '' ? 12 : 8} className={classes.alignCenter}>
                        {selected_view === '' ?
                            <div>
                                <IconButton
                                    className={classes.greenButton}
                                    aria-label="crea nuova"
                                    onClick={() => { changeViewSelection(listViews[0]) }}
                                >
                                    <Tooltip title="Crea Nuova" >
                                        <AddIcon className={classes.icon} />
                                    </Tooltip>
                                </IconButton>

                                <Tooltip title={selection.length > 0 ? "" : "Selezionare riga corrispondente alla licenza da gestire"} >
                                    <span>
                                        <IconButton
                                            className={classes.blueButton}
                                            aria-label="modifica"
                                            disabled={selection.length > 0 ? false : true}
                                            onClick={() => { changeViewSelection(listViews[1]) }}
                                        >
                                            <Tooltip title="Modifica" >
                                                <EditIcon className={classes.icon} />
                                            </Tooltip>
                                        </IconButton>

                                        <IconButton
                                            className={classes.button}
                                            aria-label="estendi"
                                            disabled={selection.length > 0 ? false : true}
                                            onClick={() => showEditDataScadDialog()}
                                        >
                                            <Tooltip title="Estendi" >
                                                <ExtendIcon className={classes.icon} />
                                            </Tooltip>
                                        </IconButton>

                                        <IconButton
                                            className={classes.blueButton}
                                            aria-label="gestisci stato"
                                            disabled={selection.length > 0 ? false : true}
                                            onClick={() => showGestioneStatoDialog()}
                                        >
                                            <Tooltip title="Gestisci Stato" >
                                                <ManageStateIcon className={classes.icon} />
                                            </Tooltip>
                                        </IconButton>

                                        <IconButton
                                            className={classes.redButton}
                                            aria-label="disassocia"
                                            disabled={selection.length > 0 ? false : true}
                                            onClick={() => showDisassociaDialog()}
                                        >
                                            <Tooltip title="Disassocia" >
                                                <DisassociaIcon className={classes.icon} />
                                            </Tooltip>
                                        </IconButton>

                                        <IconButton
                                            className={classes.button}
                                            aria-label="manage state"
                                            color="primary"
                                            disabled={selection.length > 0 ? false : true}
                                            onClick={() => { changeViewSelection(listViews[3]) }}
                                        >
                                            <Tooltip title="Gestisci Moduli" >
                                                <ModuliIcon className={classes.icon} />
                                            </Tooltip>
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </div>
                            :
                            <Typography variant="h5">
                                {selected_view}
                            </Typography>}
                    </Grid>

                    {selected_view !== '' ?
                        <Grid item xs={2} className={classes.alignCenter} >
                            {
                                // rimosso refresh griglia, qui c'è spazio per qualche altra action
                            }
                        </Grid>
                        : null
                    }

                    <ConfirmationDialog
                        isOpen={isResetLicenseDialogOpen}
                        showDialog={() => this.showResetDialog('isResetLicenseDialogOpen')}
                        title={"Annulla modifiche"}
                        message={"Confermi di voler tornare indietro e perdere le modifiche effettuate fino ad ora?"}
                        action={() => this.resetNewLicense()}
                    />

                    <ConfirmationDialog
                        isOpen={isResetEditLicenseDialogOpen}
                        showDialog={() => this.showResetDialog('isResetEditLicenseDialogOpen')}
                        title={"Annulla modifiche"}
                        message={"Confermi di voler tornare indietro e perdere le modifiche effettuate fino ad ora?"}
                        action={() => this.resetEditLicense()}
                    />

                    <ConfirmationDialog
                        isOpen={isResetNewModuliDialogOpen}
                        showDialog={() => this.showResetDialog('isResetNewModuliDialogOpen')}
                        title={"Annulla modifiche"}
                        message={"Confermi di voler tornare indietro e perdere le modifiche effettuate fino ad ora?"}
                        action={() => this.resetNewModuli()}
                    />
                </Grid>
            </Paper>
        );
    }
}

ToolbarGestioneLicenzeCmp.propTypes = {
    refreshListaLicenze: PropTypes.func.isRequired,
    changeViewSelection: PropTypes.func.isRequired,

    resetCreateLicense: PropTypes.func.isRequired,
    resetModuli: PropTypes.func.isRequired,
    resetEditLicenseData: PropTypes.func.isRequired,

    selected_view: PropTypes.string.isRequired,
    selection: PropTypes.arrayOf(PropTypes.number),


    showEditDataScadDialog: PropTypes.func.isRequired,
    showGestioneStatoDialog: PropTypes.func.isRequired,
    showDisassociaDialog: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(ToolbarGestioneLicenzeCmp);